var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 16.8C12.34 16.8 12.6252 16.6848 12.8556 16.4544C13.0852 16.2248 13.2 15.94 13.2 15.6V11.76L14.28 12.84C14.5 13.06 14.78 13.17 15.12 13.17C15.46 13.17 15.74 13.06 15.96 12.84C16.18 12.62 16.29 12.34 16.29 12C16.29 11.66 16.18 11.38 15.96 11.16L12.84 8.04C12.72 7.92 12.59 7.8348 12.45 7.7844C12.31 7.7348 12.16 7.71 12 7.71C11.84 7.71 11.69 7.7348 11.55 7.7844C11.41 7.8348 11.28 7.92 11.16 8.04L8.04 11.16C7.82 11.38 7.71 11.66 7.71 12C7.71 12.34 7.82 12.62 8.04 12.84C8.26 13.06 8.54 13.17 8.88 13.17C9.22 13.17 9.5 13.06 9.72 12.84L10.8 11.76V15.6C10.8 15.94 10.9152 16.2248 11.1456 16.4544C11.3752 16.6848 11.66 16.8 12 16.8ZM12 24C10.34 24 8.78 23.6848 7.32 23.0544C5.86 22.4248 4.59 21.57 3.51 20.49C2.43 19.41 1.5752 18.14 0.9456 16.68C0.3152 15.22 0 13.66 0 12C0 10.34 0.3152 8.78 0.9456 7.32C1.5752 5.86 2.43 4.59 3.51 3.51C4.59 2.43 5.86 1.5748 7.32 0.9444C8.78 0.3148 10.34 0 12 0C13.66 0 15.22 0.3148 16.68 0.9444C18.14 1.5748 19.41 2.43 20.49 3.51C21.57 4.59 22.4248 5.86 23.0544 7.32C23.6848 8.78 24 10.34 24 12C24 13.66 23.6848 15.22 23.0544 16.68C22.4248 18.14 21.57 19.41 20.49 20.49C19.41 21.57 18.14 22.4248 16.68 23.0544C15.22 23.6848 13.66 24 12 24Z",
    fill: "#007AB8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortUp);
export default __webpack_public_path__ + "static/media/sort_up.975fbc408cc2c26701a081244aafceb5.svg";
export { ForwardRef as ReactComponent };